import { Button, Toolbar, ToolbarItem } from "@progress/kendo-react-buttons"
import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle } from "mdbreact"
import { useDispatch } from "react-redux"
import { addEditUser, toggleAddEditUserModal } from "../../../containers/User/userSlice"
import { RootState } from "../../../rootReducer"
import { SpinnerFragment } from "../../../shared/CommonItems"
import { useAppSelector } from "../../../store"
import { PermissionsChecker } from "../../Shared/permissionChecker"
import AssignUserDealer from "./AssignUserDealer"
import BasicUserDetails from "./Details"

const AddEditUser = () => {
    const dispatch = useDispatch()
    const isAddEditModalToggled = useAppSelector((state: RootState) => state.containers.users.isAddEditModalToggled)
    const isAddEditModalLoading = useAppSelector((state: RootState) => state.containers.users.isAddEditModalLoading)
    const selectedUser = useAppSelector((state: RootState) => state.containers.users.selectedUser)
    const selectedUserRole = useAppSelector((state: RootState) => state.containers.users.selectedUserRole)
    const userRoleLoading = useAppSelector((state: RootState) => state.containers.users.userRoleLoading)

    return (
        <MDBModal staticBackdrop animationDirection="right" show={isAddEditModalToggled} tabIndex="-1">
            <MDBModalDialog position="top right modal-lg" side>
                <MDBModalContent className="full-height">
                    <MDBModalHeader>
                        <MDBModalTitle className="text-muted">User</MDBModalTitle>
                        <MDBBtn
                            color="none"
                            className="btn-close"
                            onClick={() => dispatch(toggleAddEditUserModal(false))}
                        ></MDBBtn>
                    </MDBModalHeader>
                    {(selectedUser.firstName !== null && selectedUser.lastName !== null && selectedUserRole !== null) && 
                        <PermissionsChecker permission={["Users.Edit"]}>
                            <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1">
                                <ToolbarItem>
                                    <Button
                                        fillMode="flat"
                                        type="button"
                                        themeColor={"primary"}
                                        iconClass="fa fa-save"
                                        onClick={() => dispatch(addEditUser())}
                                        title="Save"
                                        tabIndex={-1}
                                    >
                                        Save
                                    </Button>
                                </ToolbarItem>
                            </Toolbar>{" "}
                        </PermissionsChecker>}

                    {(isAddEditModalLoading || userRoleLoading) && <SpinnerFragment />}
                    <MDBModalBody>
                        <BasicUserDetails />
                        <AssignUserDealer />
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}

export default AddEditUser
